import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const state = {
  loading: false
}

const mutations = {
  setLoading (state, payload) {
    state.loading = payload.loading
  }
}

export default new Vuex.Store({
  state,
  mutations
})



// WEBPACK FOOTER //
// ./src/vuex/store.js